import * as React from "react";
import { BlogMetaPaper } from "../common/BlogMetaPaper";
import { MetaTitle } from "../common/MetaTitle";
import { Box } from "@mui/material";
import { TagCloud } from "react-tagcloud";
import { Link } from "gatsby";
import { useBlogPosts } from "../../../../data/hooks/useBlogPosts";
import { BlogPostData } from "../../../../data/types/BlogPostData";

const styles = {
  margin: "0px 3px",
  verticalAlign: "middle",
  display: "inline-block",
};

const customRenderer = (tag, size, colour) => {
  const { className, style, ...props } = tag.props || {};
  const fontSize = size + "px";
  const key = tag.key || tag.value;
  const tagStyle = { ...styles, colour, fontSize, ...style };

  let tagClassName = "tag-cloud-tag";
  if (className) {
    tagClassName += " " + className;
  }

  return (
    <Link
      to={`/blog/tags/${tag.value}`}
      className={tagClassName}
      style={tagStyle}
      key={key}
      {...props}
    >
      {tag.value}
    </Link>
  );
};

const getTags = (posts: BlogPostData[]) => {
  const allTags = [];

  for (let i = 0; i < posts.length; i++) {
    for (let j = 0; j < posts[i].tags.length; j++) {
      allTags.push(posts[i].tags[j]);
    }
  }

  const uniqueTags = allTags.filter((value, index) => {
    return allTags.indexOf(value) === index;
  });

  const data = [];

  for (let i = 0; i < uniqueTags.length; i++) {
    const tag = uniqueTags[i];
    const count = allTags.filter((value, index) => {
      return value == tag;
    }).length;

    data.push({
      value: tag,
      count: count,
    });
  }

  data.sort((a, b) => {
    return a.count < b.count ? 1 : -1;
  });

  return data.slice(0, 12);
};

export function BlogMetaTagCloud() {
  const posts = useBlogPosts() as BlogPostData[];
  const data = getTags(posts);
  return (
    <BlogMetaPaper>
      <MetaTitle text="Popular Tags" />
      <Box sx={{ margin: "16px", justifyContent: "center", display: "flex" }}>
        <TagCloud
          disableRandomColor
          minSize={10}
          maxSize={35}
          tags={data}
          renderer={customRenderer}
        />
      </Box>
    </BlogMetaPaper>
  );
}
